<script lang="ts">
	import RenderPresentation from "../../common/renderPresentation/RenderPresentation.svelte";
	import KeyboardControls from "../../common/renderPresentation/KeyboardControls.svelte";
	import PresentationControls from "./PresentationControls.svelte";
	import AudioVideoPlayer from "../../common/renderPresentation/AudioVideoPlayer.svelte";

	let {
		presentationId,
		isNew: _isNew = false,
	}: {
		presentationId: string;
		isNew?: boolean;
	} = $props();
</script>

<RenderPresentation
	presentationIndexURL={`${document.location.origin}/presentations/${presentationId}/index.json`}
>
	<svelte:fragment
		slot="controls"
		let:nextSlide
		let:previousSlide
		let:pause
		let:play
		let:restart
		let:toggleSubtitles
		let:slideState
		let:playQuestionAnswer
	>
		<AudioVideoPlayer {slideState} {nextSlide} {play} autoPlay={false} slideTransitionDelay={500} />
		<KeyboardControls
			{nextSlide}
			{previousSlide}
			{pause}
			{play}
			{restart}
			{toggleSubtitles}
			{slideState}
		/>
		<PresentationControls {play} {slideState} {restart} {playQuestionAnswer} />
	</svelte:fragment>
</RenderPresentation>
